import DaisyBaseService from './../../../services/DaisyBaseService';

/**
 * this is the unit service to handle the communication with the daisy backend
 **/
export default class UnitService extends DaisyBaseService {
	/**
	 * define required services here, think of the defined services inside the constructor of the superclass
	 * @param {function} - $injector to inject all services
	 **/
	constructor($injector) {
		super($injector);
		this.baseUrl += 'Transportauftraege';
		this.$storage = $injector.get('$localStorage');
	}
	
	/**
	 * get all locations
	 * @param {boolean} whether or not return units from localStorage
	 * @return {promise}
	 **/
	getUnits(cache = false) {
		if(cache) {
			return new Promise((resolve, reject) => {
				resolve(this.$storage.units);
			});
		}

		let functionUrl = '/ladeMengeneinheiten';
		let data = {};

		return this.doPost(functionUrl, data)
			.then(response => {
				this.$storage.units = response;
				return response;
			});
	}
}
